import React, { useState } from 'react';
import { FormApplicationNotificationsProps } from '../FormApplicationNotificationsBlock';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { BlockBar, BlockBarAnchor, useBlockBarCreateHref } from '../../../_lib/components/BlockBar';
import { GlobalDocumentIds } from '../../../types/GlobalDocumentIds';
import { Icons } from '../../../components/atoms/SVG';
import { FormApplicationNotificationsEditView } from '../views/FormApplicationNotificationsEditView';
import { FormApplicationNotificationsDefaultView } from '../views/FormApplicationNotificationsDefaultView';
import { useDelayed } from '../../../hooks/useDelayed';
import { Hint } from '../../../_lib/components/Hint';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

export function FormApplicationNotificationsInteractions({ views }: FormApplicationNotificationsProps) {
  const { t } = useSonTranslation('FormApplicationNotifications');
  const id = useHtmlValidId();
  const { refresh } = useRefreshBlock();

  const [activeView, setActiveView] = useState<'default' | 'edit'>('default');
  const currentActiveViewHref = useBlockBarCreateHref(
    activeView,
    { default: views.edit?.href, edit: views.default?.href },
    id,
  );

  const setDefaultView = () => {
    setActiveView('default');
    document.getElementById(GlobalDocumentIds.scrollContent)?.scrollTo({ top: 0 });
    refresh();
  };
  const delayedRefresh = useDelayed(setDefaultView);

  return (
    <>
      <BlockBar heading={t('heading')} hierarchy={4} modifier="border-bottom">
        <BlockBarAnchor
          href={currentActiveViewHref}
          text={t('blockBar.anchor')}
          svgSpriteId={activeView === 'default' ? Icons.EDIT_PENCIL : Icons.DECLINE_CROSS}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();

            if (activeView === 'default') {
              setActiveView('edit');
            } else {
              setDefaultView();
            }
          }}
          aria-controls={id}
          aria-expanded={activeView === 'edit'}
        />
      </BlockBar>
      <div id={id}>
        {activeView === 'default' && !views.default.embedded
          ? (
              <div className="form-application-notifications__default-container">
                <Hint message={t('noEmailAddressesAvailableHint')} />
              </div>
            )
          : null}
        {activeView === 'default' ? <FormApplicationNotificationsDefaultView {...views.default} /> : null}
        {activeView === 'edit'
          ? (
              <FormApplicationNotificationsEditView {...views.edit} refresh={delayedRefresh} />
            )
          : null}
      </div>
    </>
  );
}
